import { FcmToken } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseTimestampToDate } from './firebase-timestamp-to-date';

export const fcmTokenConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): FcmToken => {
    const data = snapshot.data() as Record<string, unknown>;
    const updatedAt = data.updatedAt
      ? firebaseTimestampToDate(data.updatedAt as Date)
      : undefined;
    return {
      ...data,
      id: data.token as string,
      updatedAt: updatedAt ?? undefined,
    } as FcmToken;
  },
  toFirestore: (fcmToken: FcmToken) => fcmToken,
};
